function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** @jsxRuntime classic */

/** @jsx jsx */
import { jsx } from '@emotion/core';
import { ButtonIcon } from '../components';
import * as Icons from '../icons';
import { parseTextToHTML, capitalize } from './';
/**
 * render icon form source (dynamic type)
 * @param {String|jsx} source data of icon, maybe svg text | image link | name of icon in icons store or a jsx element
 * @param {String} type text to parse text to HTML, img link to use img tag, name to use icon form icons store
 * @param {Object} options properties of Icon component if us type is name {width, height, color, viewBox, ...}
 */

const renderIcon = (source, type, options = {}) => {
  if (typeof source === 'string') {
    switch (type) {
      case 'name':
        let IconComp = Icons[capitalize(source)];

        if (IconComp) {
          return jsx(IconComp, options);
        }

        return null;

      case 'effect':
        return jsx(ButtonIcon, _extends({
          viewType: 'ghost',
          name: source
        }, options));

      case 'link':
      case 'imgLink':
        return jsx("img", _extends({
          src: source
        }, options));

      default:
        if (source.length < 20) {
          const IconComp = Icons[capitalize(source)];

          if (IconComp) {
            return jsx(IconComp, options);
          }

          return null;
        }

        return parseTextToHTML(source, options.output || options);
    }
  }

  return source;
};

export default renderIcon;